import React, { useState, useEffect } from "react";
import { CONTACT } from "../data/siteData";
import ContactForm from "./ContactForm";

function SolutionCarousel({ solutions }) {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);
  const len = solutions.length;

  useEffect(() => {
    if (paused) return;
    const timer = setInterval(() => setActive((p) => (p + 1) % len), 4000);
    return () => clearInterval(timer);
  }, [len, paused]);

  const goPrev = () => setActive((p) => (p - 1 + len) % len);
  const goNext = () => setActive((p) => (p + 1) % len);

  return (
    <div
      className="sol-carousel-wrap"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <button className="sol-carousel-arrow sol-arrow-left" onClick={goPrev} aria-label="Previous">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </button>

      <div className="sol-carousel">
        {solutions.map((sol, i) => {
          const diff = ((i - active + len) % len);
          let cls = "sol-carousel-item";
          if (diff === 0) cls += " sc-center";
          else if (diff === 1) cls += " sc-right";
          else if (diff === len - 1) cls += " sc-left";
          else cls += " sc-hidden";
          return (
            <div key={i} className={cls}>
              <h3>{sol.title}</h3>
              {sol.tagline && <p className="sol-carousel-tagline">{sol.tagline}</p>}
              <ul className="sol-carousel-items">
                {sol.items.map((item, j) => (
                  <li key={j}>
                    <strong>{item.label}:</strong> {item.desc}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>

      <button className="sol-carousel-arrow sol-arrow-right" onClick={goNext} aria-label="Next">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 18l6-6-6-6" />
        </svg>
      </button>

      <div className="sol-carousel-dots">
        {solutions.map((_, i) => (
          <span
            key={i}
            className={`sol-dot${i === active ? " active" : ""}`}
            onClick={() => setActive(i)}
          />
        ))}
      </div>
    </div>
  );
}

export default function ContactPage() {
  return (
    <>
      <section className="contact-hero">
        <div className="contact-hero-bg" />
        <div className="contact-hero-content">
          <p className="contact-hero-label">{CONTACT.label}</p>
          <h1 className="contact-hero-title">
            {CONTACT.heading[0]}<br />{CONTACT.heading[1]}
          </h1>
          <p className="contact-hero-sub">{CONTACT.subheading}</p>
        </div>
      </section>

      <section className="section solutions-section">
        <SolutionCarousel solutions={CONTACT.solutions} />
        <p className="solutions-support-note">{CONTACT.supportNote}</p>
      </section>

      <ContactForm title={CONTACT.formTitle} />
    </>
  );
}
